// Translations for the Member profile page (single member's own profile view).
const memberDict = [
  { en: "Please choose a valid image (JPG, PNG, etc.)", sw: "Tafadhali chagua picha sahihi (JPG, PNG, etc.)" },
  { en: "Image is too large. Maximum size is 5MB", sw: "Picha ni kubwa sana. Ukubwa wa juu ni 5MB" },
  { en: "Photo updated!", sw: "Picha imebadilishwa!" },
  { en: "An error occurred uploading the photo", sw: "Hitilafu imetokea kupakia picha" },
  { en: "Please fill in all required fields", sw: "Tafadhali jaza vipu vyote vya lazima" },
  { en: "Please enter a valid email (e.g. example@domain.com)", sw: "Tafadhali ingiza email sahihi (mfano: example@domain.com)" },
  { en: "Information updated!", sw: "Taarifa zimebadilishwa!" },
  { en: "An error occurred updating the information", sw: "Hitilafu imetokea kubadilisha taarifa" },
  { en: "Loading...", sw: "Inapakia..." },
  { en: "An error occurred loading the profile", sw: "Hitilafu imetokea kupakia profaili" },
  { en: "My Profile", sw: "Wasifu Wangu" },
  { en: "View and edit your personal information", sw: "Angalia na hariri taarifa zako za kibinafsi" },
  { en: "Number:", sw: "Namba:" },
  { en: "Status:", sw: "Hali:" },
  { en: "Personal Information", sw: "Taarifa ya Kibinafsi" },
  { en: "Contact", sw: "Mawasiliano" },
  { en: "Contact Information", sw: "Taarifa za Mawasiliano" },
  { en: "First Name *", sw: "Jina la Kwanza *" },
  { en: "Middle Name (Optional)", sw: "Jina la Pili (Optional)" },
  { en: "Last Name *", sw: "Jina la Ukoo *" },
  { en: "Email *", sw: "Email *" },
  { en: "Phone *", sw: "Simu *" },
  { en: "Address", sw: "Anwani" },
  { en: "Emergency Contact", sw: "Mawasiliano ya Dharura" },
  { en: "Emergency Phone", sw: "Simu ya Dharura" },
  { en: "Save", sw: "Hifadhi" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "First Name:", sw: "Jina la Kwanza:" },
  { en: "Middle Name:", sw: "Jina la Pili:" },
  { en: "Last Name:", sw: "Jina la Ukoo:" },
  { en: "Email:", sw: "Email:" },
  { en: "Phone:", sw: "Simu:" },
  { en: "Address:", sw: "Anwani:" },
  { en: "Emergency Contact:", sw: "Mgeni wa Dharura:" },
  { en: "Emergency Phone:", sw: "Simu ya Dharura:" },
  { en: "Edit", sw: "Hariri" },
];

export default memberDict;
